const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

export async function initSmoothScroll() {
  if (typeof window === "undefined") {
    return () => {};
  }

  const prefersReducedMotion = window.matchMedia(REDUCED_MOTION_QUERY).matches;
  if (prefersReducedMotion) {
    return () => {};
  }

  const { default: Lenis } = await import("lenis");

  const lenis = new Lenis({
    lerp: 0.22,
    smoothWheel: true,
    syncTouch: true,
    syncTouchLerp: 0.18,
    wheelMultiplier: 1.05,
    touchMultiplier: 1.1,
    autoRaf: false,
    anchors: true,
  });

  let rafId = null;
  let gsapTickerHandler = null;

  if (window.gsap && window.gsap.ticker) {
    gsapTickerHandler = (time) => {
      lenis.raf(time * 1000);
    };
    window.gsap.ticker.add(gsapTickerHandler);
    window.gsap.ticker.lagSmoothing(0);
  } else {
    const raf = (time) => {
      lenis.raf(time);
      rafId = window.requestAnimationFrame(raf);
    };
    rafId = window.requestAnimationFrame(raf);
  }

  if (window.ScrollTrigger) {
    lenis.on("scroll", window.ScrollTrigger.update);
    window.ScrollTrigger.addEventListener("refresh", () => {
      lenis.resize();
    });
    window.ScrollTrigger.refresh();
  }

  return () => {
    if (gsapTickerHandler && window.gsap && window.gsap.ticker) {
      window.gsap.ticker.remove(gsapTickerHandler);
    }
    if (rafId) {
      window.cancelAnimationFrame(rafId);
    }
    lenis.destroy();
  };
}
